import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconVerticalLine({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      width="1"
      height={h}
      viewBox="0 0 2 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 0.5V15.5" stroke="#414141" />
    </svg>
  );
}
